/** 株式会社キャデック設立年（平成3年5月） */
export const COMPANY_FOUNDED_YEAR = 1991;

const PREVIEW_YEAR_PARAM = 'cadecSimYear';

/** 確認用: URL に ?cadecSimYear=2031 等を付けるとその年として表示 */
export function getPreviewTimelineYear(): number | null {
  if (typeof window === 'undefined') return null;
  const raw = new URLSearchParams(window.location.search).get(PREVIEW_YEAR_PARAM);
  if (raw == null || raw === '') return null;
  const n = Number.parseInt(raw, 10);
  if (!Number.isFinite(n) || n < COMPANY_FOUNDED_YEAR) return null;
  return n;
}

export function getTimelineYear(): number {
  return getPreviewTimelineYear() ?? new Date().getFullYear();
}

/**
 * 設立からの経過年数が 5 の倍数の年だけ周年（30th, 35th, 40th …）を返す。
 * それ以外の年は null（右下ブロック非表示）。
 */
export function getAnniversaryMilestone(timelineYear: number): number | null {
  const years = timelineYear - COMPANY_FOUNDED_YEAR;
  if (years <= 0 || years % 5 !== 0) return null;
  return years;
}

export function anniversaryOrdinalSuffix(n: number): string {
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return 'th';
  switch (n % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}
